import { Injectable } from '@angular/core';
import { MIN_DURATION, MAX_DURATION } from '@app/core/constants';
import * as _ from 'lodash';
import moment from 'moment';
@Injectable({
    providedIn: 'root'
})
export class UtilsService {
    constructor() {}

    public getDiffKeys(obj1: any, obj2: any, keys: any[]) {
        const difference: string[] = [];
        keys.forEach((key) => {
            const prop1 = _.get(obj1, key);
            const prop2 = _.get(obj2, key);

            if (!_.isEqual(prop1, prop2)) {
                difference.push(key);
            }
        });

        return difference;
    }

    public createSemanticTimeIntervals(intervalLength: number) {
        const startDay = moment().startOf('day');
        const endDay = moment().endOf('day');

        function* generateIntervals(startTime: moment.Moment, endTime: moment.Moment) {
            if (startTime.isAfter(endTime)) {
                return;
            }
            yield moment(startTime, 'HH:mm');
            yield* generateIntervals(startTime.add(intervalLength, 'minutes'), endTime);
        }

        const momentTimeIntervals = Array.from(generateIntervals(startDay, endDay)) as moment.Moment[];
        return this.transformToSemanticValues(momentTimeIntervals);
    }

    /** Transform an array of moment times to a Semantic-compatible format for time range dropdowns */
    private transformToSemanticValues(timeIntervals: moment.Moment[]): Array<{ value: string; name: string }> {
        return timeIntervals.map((interval) => {
            return {
                value: interval.format('HH:mm'),
                name: interval.format('h:mm a')
            };
        });
    }

    public createDurations() {
        const initialDurationValues = [5, 15, 20, 25, 50];
        function* createDurations(start: number, end: number) {
            if (start > end) {
                return;
            }
            yield start;
            yield* createDurations(start + 15, end);
        }
        const allDurationsValues = [
            ...initialDurationValues,
            ...(Array.from(createDurations(MIN_DURATION, MAX_DURATION)) as number[])
        ];

        return allDurationsValues.sort((a, b) => a - b);
    }

    public getMeetingDuration(duration: number, hoursMinutes: [string, string]) {
        const hours = Math.floor(duration / 60);
        const minutes = duration % 60;

        if (hours && minutes) {
            return `${hoursMinutes[0]} ${hoursMinutes[1]}`;
        } else if (hours) {
            return `${hoursMinutes[0]}`;
        } else {
            return `${hoursMinutes[1]}`;
        }
    }
}
